/**
 * @KotlinClass com.sucsoft.organization.basic.management.commons.vo.AuthoxObjectTreeVO
 */
export class AuthoxObjectTreeVO {
    /**
     * @NomosDefineDescription "子项"
     * @NomosDefineType {"family":"array","elementType":{"family":"object","className":"com.sucsoft.organization.basic.management.commons.vo.AuthoxObjectTreeVO","elementTypes":[]}}
     * @NomosGenericElements []
     */
    children?: Array<AuthoxObjectTreeVO>;
    /**
     * @NomosDefineDescription "id"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    id!: string;
    /**
     * @NomosDefineDescription "层级"
     * @NomosDefineType {"family":"number"}
     * @NomosGenericElements []
     */
    level!: number;
    /**
     * @NomosDefineDescription "标题"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    name!: string;
    /**
     * @NomosDefineDescription "父级树节点编码"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    parentTreeCode?: string;
    /**
     * @NomosDefineDescription "树节点编码"
     * @NomosDefineType {"family":"string"}
     * @NomosGenericElements []
     */
    treeCode!: string;
}
